import { createFileRoute } from "@tanstack/react-router";
import DoesFederalBcbsCoverSaint from "@/pages/DoesFederalBcbsCoverSaint";
export const Route = createFileRoute("/does-federal-bcbs-cover-saint")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "Does Federal Blue Cross Blue Shield Cover SAINT? | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "If you have federal BCBS (FEP Blue), SAINT TMS may be covered when certain criteria are met. We verify your benefits for free — call 954-827-9793.",
        },
        {
          property: "og:title",
          content:
            "Does Federal Blue Cross Blue Shield Cover SAINT? | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "If you have federal BCBS (FEP Blue), SAINT TMS may be covered when certain criteria are met. We verify your benefits for free — call 954-827-9793.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/does-federal-bcbs-cover-saint",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/does-federal-bcbs-cover-saint",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <DoesFederalBcbsCoverSaint />;
}
